import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";

import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertToDateString,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage, isUsraRole } from "../helper/Method";
import { addMember } from "../member/ApiMember";
import SelectUnit from "../shared/SelectUnit";
import { viewUsraReceiptPdf } from "../shared/receiptViewer";
import { ApiFinance } from "./ApiFinance";
import { ApiFund } from "./ApiFund";

const bulkCellStyle = {
  padding: "10px 12px",
  color: "#676a6c",
  verticalAlign: "middle",
};
const bulkHeaderStyle = {
  padding: "10px 12px",
  color: "#1a6b5c",
  fontWeight: 700,
  fontSize: 12,
  background: "#d8efe9",
  borderBottom: "2px solid #1ab394",
  whiteSpace: "nowrap",
};
const bulkInputStyle = {
  border: "1px solid #8aa8a2",
  backgroundColor: "#ffffff",
  color: "#2f4050",
  fontWeight: 500,
  minHeight: 36,
  boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.06)",
};

const AddBulkFund = ({ history }) => {
  const { t } = useTranslation();

  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
  });
  const unitId = values.unit.value;
  const [loading, setLoading] = useState(false);
  const [fundValues, setFundValues] = useState({});
  const [fundValuesList, setFundValuesList] = useState([]);
  const [selectedDatesList, setSelectedDatesList] = useState([]);
  const [serverError, setServerError] = useState("");
  const [errors, setErrors] = useState({
    month: "",
    year: "",
  });
  const [members, setMembers] = useState([]);
  const [searchBtnClicked, setSearchBtnClicked] = useState(false);
  const [receiptType, setReceiptType] = useState(isUsraRole() ? "digital" : "physical");

  const fetchUnitMembers = async () => {
    try {
      setLoading(true);
      setSearchBtnClicked(true);
      const res = await addMember().getUnitMembersForSelecting(
        values.unit.value,
      );
      if (res.data.length === 0) {
        setMembers([]);
      } else {
        setMembers(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    let tempYear = currentDate.getFullYear();
    let tempMonth = currentDate.getMonth() + 1;
    setFundValues({
      unitId: unitId,
      month: tempMonth,
      year: tempYear,
      funds: [],
    });
  }, [unitId]);
  const [disablesubmitButton, setDisableSubmitButton] = useState(true);
  useEffect(() => {
    if (members?.length !== 0) {
      let currentDate = new Date();
      let temp = [];
      let tempDates = [];
      members.forEach((record) => {
        temp.push({
          memberId: record?.id,
          memberName: record?.name,
          serialNumber: record?.serialNumber || record?.regNo || "",
          receiptNumber: "",
          amount: null,
          date: currentDate,
        });

        tempDates.push({
          memberId: record?.id,
          date: currentDate,
        });
      });

      setSelectedDatesList(tempDates);
      setFundValuesList(temp);
    } else {
      setSelectedDatesList([]);
      setFundValuesList([]);
    }
  }, [members]);
  const validate = () => {
    let temp = {};
    temp.month = fundValues.month ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_month_error" />
    );
    temp.year = fundValues.year ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_year_error" />
    );
    temp.selectedBankAccountErrorMsg = selectedBankAccount
      ? ""
      : "Please select a Bank Account";
    temp.selectedInfaqHeadErrorMsg = selectedInfaqHead
      ? ""
      : "Please select an Account Head";

    const hasAddressError = fundValuesList.some(
      (f) => Number(f.amount) >= 5000 && (!f.address || !f.address.trim())
    );
    if (hasAddressError) {
      temp.addressError = "Address is required for entries equal to or exceeding 5,000";
      swal({
        title: "Address Required",
        text: "Address is required for entries equal to or exceeding 5,000.",
        icon: "error",
        buttons: "OK",
      });
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "") && !hasAddressError;
  };

  const handleInputChangeDate = (value, index) => {
    let tempValues = [...selectedDatesList];
    if (!tempValues[index]) {
      tempValues[index] = {};
    }
    tempValues[index].date = value;

    setSelectedDatesList(tempValues);
  };

  const handleInputChange = (e, index) => {
    let { name, value } = e.target;
    if (name === "amount") {
      value = value.replace(/[^0-9.]/g, "");
    }
    setDisableSubmitButton(false);
    let tempValues = [...fundValuesList];
    if (!tempValues[index]) {
      tempValues[index] = {};
    }
    tempValues[index][name] = value;

    setFundValuesList(tempValues);
  };

  const handleKeyDown = (e, index, name) => {
    const hasAddressCol = fundValuesList.some((f) => Number(f.amount) >= 5000);

    if (e.key === "ArrowUp") {
      e.preventDefault();
      let targetIndex = index - 1;
      while (targetIndex >= 0) {
        const targetElement = document.getElementById(`${name}-${targetIndex}`);
        if (targetElement && !targetElement.disabled) {
          targetElement.focus();
          targetElement.select();
          break;
        }
        targetIndex--;
      }
    } else if (e.key === "ArrowDown" || e.key === "Enter") {
      e.preventDefault();
      let targetIndex = index + 1;
      while (targetIndex < fundValuesList.length) {
        const targetElement = document.getElementById(`${name}-${targetIndex}`);
        if (targetElement && !targetElement.disabled) {
          targetElement.focus();
          targetElement.select();
          break;
        }
        targetIndex++;
      }
    } else if (e.key === "ArrowLeft") {
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      if (selectionStart === 0 && selectionEnd === 0) {
        if (name === "amount" && receiptType === "physical") {
          e.preventDefault();
          const targetElement = document.getElementById(`receiptNumber-${index}`);
          if (targetElement && !targetElement.disabled) {
            targetElement.focus();
            targetElement.select();
          }
        } else if (name === "address") {
          e.preventDefault();
          const targetElement = document.getElementById(`amount-${index}`);
          if (targetElement && !targetElement.disabled) {
            targetElement.focus();
            targetElement.select();
          }
        }
      }
    } else if (e.key === "ArrowRight") {
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      const valLength = e.target.value ? e.target.value.length : 0;
      if (selectionStart === valLength && selectionEnd === valLength) {
        if (name === "receiptNumber") {
          e.preventDefault();
          const targetElement = document.getElementById(`amount-${index}`);
          if (targetElement && !targetElement.disabled) {
            targetElement.focus();
            targetElement.select();
          }
        } else if (name === "amount" && hasAddressCol) {
          const targetElement = document.getElementById(`address-${index}`);
          if (targetElement && !targetElement.disabled) {
            e.preventDefault();
            targetElement.focus();
            targetElement.select();
          }
        }
      }
    }
  };

  const [duplicateRows, setDuplicateRows] = useState([]);

  const handleSubmit = () => {
    const frontDuplicates = validateReceiptsFrontend();

    if (frontDuplicates.length > 0) {
      setDuplicateRows(frontDuplicates);
      return;
    }

    setDuplicateRows([]);
    if (validate()) {
      setLoading(true);
      const updatedFunds = fundValuesList.map((fund) => {
        const matchingDate = selectedDatesList.find(
          (date) => date.memberId === fund.memberId,
        );
        return {
          ...fund,
          receiptNumber: (isUsraRole() || receiptType === "digital") ? "" : fund.receiptNumber,
          date: matchingDate ? convertToDateString(matchingDate.date) : null,
          generateDigitalReceipt: isUsraRole() ? true : receiptType === "digital",
          address: Number(fund.amount) >= 5000 ? (fund.address || "") : "",
          isRafiq: true,
        };
      });

      // derive month/year for the bulk payload from the current date
      const currentDate = new Date();
      const monthToSend = currentDate.getMonth() + 1;
      const yearToSend = currentDate.getFullYear();

      fundValues.funds = updatedFunds;
      fundValues.month = monthToSend;
      fundValues.year = yearToSend;
      fundValues.codeId = selectedInfaqHead?.value || "";
      fundValues.bankAccountId = selectedBankAccount?.value || "";
      const hasAtLeastOneValidFund = fundValuesList.some(
        (item) => Number(item.amount) > 0,
      );

      if (!hasAtLeastOneValidFund) {
        swal({
          title: t("all_member_zero_amount_error"),
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
        return;
      }
      ApiFund()
        .addBulkFund(fundValues)
        .then((res) => {
          if (res.data.statusCode === "200") {
            const receiptTokens = res.data.receiptTokens || [];
            swal({
              title: t("member_member_detail_fund_added"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons:
                receiptTokens.length > 0
                  ? {
                      OK: true,
                      viewReceipt: {
                        text: t("common_view_receipt") || "View Receipt",
                        value: "viewReceipt",
                      },
                    }
                  : "OK",
            }).then((value) => {
              if (value === "viewReceipt" && receiptTokens[0]) {
                viewUsraReceiptPdf({ receiptToken: receiptTokens[0], t });
              }
              setLoading(false);
              history.goBack();
            });
          } else {
            const duplicateCount = res.data.duplicateCount;
            swal({
              title:
                `${duplicateCount} ${t(res.data.message)}` ||
                t("all_member_zero_amount_error"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "error",
              buttons: "OK",
            });
            if (res.data.duplicateList && res.data.duplicateList.length > 0) {
              // map receipt numbers to row indexes
              const backendDupIndexes = fundValuesList
                .map((item, idx) =>
                  res.data.duplicateList.includes(item.receiptNumber)
                    ? idx
                    : null,
                )
                .filter((idx) => idx !== null);

              setDuplicateRows(backendDupIndexes);
            }
            setLoading(false);
          }
        })
        .catch((err) => {
          const apiMessage =
            err.response?.data?.message || err.response?.data?.Message;
          if (err.response?.data && typeof err.response.data === "string" && err.response.data.length < 100) {
            setServerError(err.response.data);
          }
          swal({
            title: t(apiMessage || "member_member_detail_fund_added_error"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response?.data);
          setLoading(false);
        });
    }
  };
  const validateReceiptsFrontend = () => {
    if (receiptType === "digital") return [];

    let duplicates = [];
    let seen = new Set();

    fundValuesList.forEach((item, index) => {
      if (item.receiptNumber && seen.has(item.receiptNumber)) {
        duplicates.push(index);
      }
      seen.add(item.receiptNumber);
    });

    return duplicates;
  };

  const handleReceiptTypeChange = (e) => {
    const value = e.target.value;
    setReceiptType(value);
    setDuplicateRows([]);

    if (value === "digital") {
      setFundValuesList((prev) =>
        prev.map((fund) => ({
          ...fund,
          receiptNumber: "",
        })),
      );
    }
  };

  const [bankAccountList, setBankAccountList] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [selectedInfaqHead, setSelectedInfaqHead] = useState(null);

  useEffect(() => {
    const financeApi = ApiFinance();
    financeApi
      .GetFinanceSubCategoryAccountsByCode("infaq")
      .then((res) => {
        if (res?.data) {
          setInfaqHeads(res.data);

          // default select first one
          if (res.data.length > 0) {
            setSelectedInfaqHead(res.data[0]);
            setFundValues((prev) => ({
              ...prev,
              codeId: res.data[0].value,
            }));
          }
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const financeApi = ApiFinance();
    financeApi.GetFinanceBankAccounts(loggedInUnitId).then((res) => {
      const filteredAccounts = (res.data || []).filter(
        (account) =>
          account?.label1 === "cash_in_hand_account" ||
          account?.label1 === "amanat_account",
      );

      if (filteredAccounts.length > 0) {
        setBankAccountList(filteredAccounts);
        const defaultAccount =
          filteredAccounts.find(
            (account) => account?.label1 === "cash_in_hand_account",
          ) || filteredAccounts[0];

        setSelectedBankAccount(defaultAccount);
        setFundValues((prev) => ({
          ...prev,
          bankAccountId: defaultAccount.value,
        }));
      } else {
        // when array is empty
        setBankAccountList([]);
        setSelectedBankAccount(null);
        setFundValues((prev) => ({
          ...prev,
          bankAccountId: null,
        }));
      }
    });
  }, [loggedInUnitId]);

  const handleBankAccountChange = (selected) => {
    setSelectedBankAccount(selected);

    setFundValues((prev) => ({
      ...prev,
      bankAccountId: selected?.value || "",
    }));

    setErrors((prev) => ({
      ...prev,
      selectedBankAccountErrorMsg: selected
        ? ""
        : "Please select a Bank Account",
    }));
  };
  const handleInfaqHeadChange = (selected) => {
    setSelectedInfaqHead(selected);

    setFundValues((prev) => ({
      ...prev,
      codeId: selected ? selected.value : "",
    }));

    setErrors((prev) => ({
      ...prev,
      selectedInfaqHeadErrorMsg: selected
        ? ""
        : "Please select an Account Head",
    }));
  };
  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <div className="ibox">
        <div
          className="ibox-title"
          style={{
            borderTop: "2px solid #1ab394",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h5 style={{ color: "#1a6b5c", fontWeight: 700, marginBottom: 0 }}>
            {<GetLanguageString props="funds_add_bulk_fund" />}
          </h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>
        <div className="ibox-content">
          {serverError && <h4 className="text-danger">{serverError}</h4>}

          <div
            style={{
              padding: "16px 18px",
              background: "linear-gradient(180deg, #f8fffd 0%, #ffffff 100%)",
              border: "1px solid #e7eaec",
              borderLeft: "4px solid #1ab394",
              borderRadius: 6,
              boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
              marginBottom: 8,
            }}
          >
            <SelectUnit
              values={values}
              setValues={setValues}
              unitId={values.unit.value}
              filterUnitTypes={["Usra", "UsraMuavin", "Munfarid"]}
            />
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="col-form-label" style={{ fontWeight: 600, color: "#2f4050" }}>
                    <GetLanguageString props="fund_bank_account" />
                  </Label>
                  <Select
                    options={bankAccountList}
                    value={selectedBankAccount}
                    placeholder="Select bank account"
                    onChange={handleBankAccountChange}
                    className="basic-single no-drag"
                    classNamePrefix="select"
                    isDisabled
                  />
                  {errors.selectedBankAccountErrorMsg && (
                    <h4 className="text-error">{errors.selectedBankAccountErrorMsg}</h4>
                  )}
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label className="col-form-label" style={{ fontWeight: 600, color: "#2f4050" }}>
                    <GetLanguageString props="fund_account_head" />
                  </Label>
                  <Select
                    options={infaqHeads}
                    value={selectedInfaqHead}
                    placeholder="Select Infaq Head"
                    onChange={handleInfaqHeadChange}
                    className="basic-single no-drag"
                    classNamePrefix="select"
                  />
                  {errors.selectedInfaqHeadErrorMsg && (
                    <h4 className="text-error">{errors.selectedInfaqHeadErrorMsg}</h4>
                  )}
                </FormGroup>
              </Col>
              {!isUsraRole() && (
                <Col md="4">
                  <FormGroup>
                    <Label className="col-form-label d-block" style={{ fontWeight: 600, color: "#2f4050" }}>
                      <GetLanguageString props="funds_receipt_number" />
                    </Label>
                    <div
                      className="no-drag d-flex align-items-center"
                      style={{ gap: 10, minHeight: 38 }}
                    >
                      <Label
                        check
                        className="mb-0"
                        style={{
                          padding: "8px 12px",
                          borderRadius: 6,
                          border: receiptType === "physical" ? "1px solid #1ab394" : "1px solid #e7eaec",
                          background: receiptType === "physical" ? "#e8f8f5" : "#fff",
                          color: "#2f4050",
                          fontWeight: 600,
                        }}
                      >
                        <Input
                          type="radio"
                          name="bulkReceiptType"
                          value="physical"
                          checked={receiptType === "physical"}
                          onChange={handleReceiptTypeChange}
                        />{" "}
                        {<GetLanguageString props="funds_physical_receipt" />}
                      </Label>
                      <Label
                        check
                        className="mb-0"
                        style={{
                          padding: "8px 12px",
                          borderRadius: 6,
                          border: receiptType === "digital" ? "1px solid #1ab394" : "1px solid #e7eaec",
                          background: receiptType === "digital" ? "#e8f8f5" : "#fff",
                          color: "#2f4050",
                          fontWeight: 600,
                        }}
                      >
                        <Input
                          type="radio"
                          name="bulkReceiptType"
                          value="digital"
                          checked={receiptType === "digital"}
                          onChange={handleReceiptTypeChange}
                        />{" "}
                        {<GetLanguageString props="funds_digital_receipt" />}
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              )}
            </Row>
            <div className="text-end">
              <Button color="primary" onClick={fetchUnitMembers}>
                {<GetLanguageString props="common_search" />}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {searchBtnClicked && (
        <>
          {!loading ? (
            <>
              <div className="ibox">
                <div
                  className="ibox-title"
                  style={{ borderTop: "2px solid #1ab394" }}
                >
                  <h5 style={{ color: "#1a6b5c", fontWeight: 700 }}>
                    {<GetLanguageString props="funds_add_bulk_fund" />}
                    {fundValuesList.length > 0 ? (
                      <span
                        style={{
                          marginLeft: 10,
                          background: "#e8f8f5",
                          color: "#1ab394",
                          borderRadius: 999,
                          padding: "2px 10px",
                          fontSize: 12,
                          fontWeight: 700,
                        }}
                      >
                        {fundValuesList.length}
                      </span>
                    ) : null}
                  </h5>
                </div>
                <div className="ibox-content" style={{ paddingTop: 12 }}>
                  {serverError && <h4 className="text-danger">{serverError}</h4>}
                  {fundValuesList.length !== 0 ? (
                    <>
                      <div style={{ overflowX: "auto" }}>
                        <Table
                          responsive
                          className="mb-0"
                          style={{ background: "#fff", border: "1px solid #e7eaec" }}
                        >
                          <thead>
                            <tr>
                              <th style={bulkHeaderStyle}>#</th>
                              <th style={bulkHeaderStyle}>
                                <GetLanguageString props="member_report_member_serialNumber" />
                              </th>
                              <th style={bulkHeaderStyle}>
                                <GetLanguageString props="common_name" />
                              </th>
                              <th style={bulkHeaderStyle}>
                                <GetLanguageString props="funds_date" />
                              </th>
                              {receiptType === "physical" && (
                                <th style={bulkHeaderStyle}>
                                  <GetLanguageString props="funds_receipt_number" />
                                </th>
                              )}
                              <th style={bulkHeaderStyle}>
                                <GetLanguageString props="funds_add_fund_amount" />
                              </th>
                              {fundValuesList.some((f) => Number(f.amount) >= 5000) && (
                                <th style={bulkHeaderStyle}>
                                  <GetLanguageString props="member_address" />
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {fundValuesList?.map((record, index) => (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: "1px solid #cfe3de",
                                  background: duplicateRows.includes(index)
                                    ? "#fde8e8"
                                    : index % 2 === 0
                                    ? "#ffffff"
                                    : "#e6f3ef",
                                }}
                              >
                                <td style={bulkCellStyle}>{index + 1}</td>
                                <td style={bulkCellStyle}>{record?.serialNumber || "-"}</td>
                                <td style={{ ...bulkCellStyle, fontWeight: 600, color: "#2f4050" }}>
                                  {applyClassToCharacters(record?.memberName, "ur")}
                                </td>
                                <td style={bulkCellStyle}>
                                  <DatePicker
                                    minDate={
                                      new Date(
                                        new Date().getFullYear(),
                                        new Date().getMonth(),
                                        1,
                                      )
                                    }
                                    maxDate={new Date()}
                                    placeholderText="dd/mm/yyyy"
                                    className="form-control no-drag"
                                    dateFormat="dd/MM/yyyy"
                                    selected={selectedDatesList[index]?.date}
                                    onChange={(v) => handleInputChangeDate(v, index)}
                                    customInput={
                                      <Input className="no-drag" style={bulkInputStyle} />
                                    }
                                  />
                                </td>
                                {receiptType === "physical" && (
                                  <td style={bulkCellStyle}>
                                    <Input
                                      autoFocus={index === 0}
                                      type="text"
                                      className="no-drag"
                                      name="receiptNumber"
                                      id={`receiptNumber-${index}`}
                                      value={fundValuesList[index]?.receiptNumber ?? ""}
                                      onChange={(e) => handleInputChange(e, index)}
                                      onKeyDown={(e) => handleKeyDown(e, index, "receiptNumber")}
                                      style={bulkInputStyle}
                                    />
                                  </td>
                                )}
                                <td style={bulkCellStyle}>
                                  <Input
                                    type="text"
                                    className="no-drag"
                                    name="amount"
                                    id={`amount-${index}`}
                                    value={fundValuesList[index]?.amount ?? ""}
                                    onChange={(e) => handleInputChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index, "amount")}
                                    style={bulkInputStyle}
                                  />
                                </td>
                                {fundValuesList.some((f) => Number(f.amount) >= 5000) && (
                                  <td style={bulkCellStyle}>
                                    <Input
                                      type="text"
                                      className="no-drag"
                                      name="address"
                                      id={`address-${index}`}
                                      disabled={Number(fundValuesList[index]?.amount) < 5000}
                                      placeholder={Number(fundValuesList[index]?.amount) >= 5000 ? "Enter address" : ""}
                                      value={
                                        Number(fundValuesList[index]?.amount) >= 5000
                                          ? fundValuesList[index]?.address ?? ""
                                          : ""
                                      }
                                      onChange={(e) => handleInputChange(e, index)}
                                      onKeyDown={(e) => handleKeyDown(e, index, "address")}
                                      style={{
                                        ...bulkInputStyle,
                                        backgroundColor:
                                          Number(fundValuesList[index]?.amount) < 5000
                                            ? "#f1f5f4"
                                            : "#ffffff",
                                      }}
                                    />
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 8,
                          marginTop: 16,
                          paddingTop: 12,
                          borderTop: "1px solid #e7eaec",
                        }}
                      >
                        <Button color="white" onClick={() => history.goBack()}>
                          {<GetLanguageString props="common_cancel" />}
                        </Button>
                        <Button
                          color="primary"
                          onClick={() => handleSubmit()}
                          disabled={disablesubmitButton}
                        >
                          {<GetLanguageString props="common_save_changes" />}
                        </Button>
                      </div>
                    </>
                  ) : (
                    <NoResult />
                  )}
                </div>
              </div>
            </>
          ) : (
            LoadingSpinner()
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(AddBulkFund);
